module.exports = __webpack_public_path__ + "static/img/iphoneSearch.8b3a511.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/iphoneSearch.png
// module id = 2mdq
// module chunks = 1